import { Navigate } from 'react-router-dom';
import { useCrmView } from '@/hooks/useCrmView';
import type { ModuloDelMenu } from '@/lib/sidebar-grupos';

/**
 * Guarda de MÓDULO: una pantalla que este negocio no usa no se abre, ni siquiera
 * escribiendo la URL a mano.
 *
 * Ocultar la entrada del menú no alcanza. Osito no instala nada, así que
 * `/jobs` o `/tracking` no le sirven de nada — pero siguen existiendo en el
 * producto, y alguien puede llegar por un enlace viejo, por el historial del
 * navegador o escribiéndola. Lo que se encuentra ahí es la pantalla de otro
 * rubro, con su vocabulario y sus columnas vacías.
 *
 * ── QUÉ NO ES ESTO ─────────────────────────────────────────────────────────
 * **No es un permiso.** No protege datos: los endpoints de esas pantallas
 * siguen ahí y siguen exigiendo ADMIN. Esto decide qué partes del producto ve
 * este cliente, que es otra cosa. Por eso vive en el enrutador y no pretende
 * ser una frontera de seguridad (CANON D4: un permiso se aplica en la consulta,
 * no al pintar — esto no es un permiso).
 *
 * Mientras la configuración carga se DEJA PASAR: parpadear a la pantalla de
 * inicio y volver es peor que mostrar medio segundo de más, y si la consulta
 * falla el panel queda usable en vez de mutilado.
 */
export function ModuloRoute({
  modulo,
  children,
}: {
  modulo: ModuloDelMenu;
  children: React.ReactNode;
}) {
  const modulos = useCrmView()?.osito?.modulos;

  // `undefined` = todavía no cargó, o la config no lo declara → pasa.
  if (modulos && modulos[modulo] === false) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
